import type { WallShape } from '@walls/store';

export interface RectangleShapeAttributes {
  fillColor?: string;
  fillOpacity: number;
  height: number;
  lineColor?: string;
  lineOpacity: number;
  lineThickness: number;
  width: number;
  x: number;
  y: number;
}

export interface LineShapeAttributes {
  endX: number;
  endY: number;
  lineColor?: string;
  lineOpacity: number;
  lineThickness: number;
  startX: number;
  startY: number;
}

export interface TextShapeAttributes {
  color: string;
  fontFamily: string;
  fontSize: number;
  text: string;
  x: number;
  y: number;
}

export function getShapeType(shape: WallShape) {
  return shape.type.trim().toLowerCase();
}

export function getRectangleAttributes(shape: WallShape): RectangleShapeAttributes {
  const attributes = shape.attributes;

  return {
    fillColor: getString(attributes.fillColor),
    fillOpacity: getNumber(attributes.fillOpacity, 100),
    height: getNumber(attributes.height, 0),
    lineColor: getString(attributes.lineColor),
    lineOpacity: getNumber(attributes.lineOpacity, 100),
    lineThickness: getNumber(attributes.lineThickness, 1),
    width: getNumber(attributes.width, 0),
    x: getNumber(attributes.x, 0),
    y: getNumber(attributes.y, 0),
  };
}

export function getLineAttributes(shape: WallShape): LineShapeAttributes {
  const attributes = shape.attributes;

  return {
    endX: getNumber(attributes.endX, 0),
    endY: getNumber(attributes.endY, 0),
    lineColor: getString(attributes.lineColor),
    lineOpacity: getNumber(attributes.lineOpacity, 100),
    lineThickness: getNumber(attributes.lineThickness, 1),
    startX: getNumber(attributes.startX, 0),
    startY: getNumber(attributes.startY, 0),
  };
}

export function getTextAttributes(shape: WallShape): TextShapeAttributes {
  const attributes = shape.attributes;

  return {
    color: getString(attributes.color) ?? '#000000',
    fontFamily: getString(attributes.fontFamily) ?? 'Arial,Arial,Helvetica,sans-serif',
    fontSize: getNumber(attributes.fontSize, 18),
    text: getString(attributes.text) ?? '',
    x: getNumber(attributes.x, 0),
    y: getNumber(attributes.y, 0),
  };
}

function getNumber(value: unknown, fallback: number) {
  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? numericValue : fallback;
}

function getString(value: unknown) {
  return typeof value === 'string' && value.trim().length > 0 ? value : undefined;
}
